import { all, fork } from 'redux-saga/effects';
import userSaga from './sagas/userSaga';
import inputValidationsSaga from './sagas/inputValidationsSaga';

export default function* rootSaga() {
    yield all([
        fork(userSaga),
        fork(inputValidationsSaga)
    ])
}



// WEBPACK FOOTER //
// ./src/rootSaga.js